// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trackon-root .ant-btn-primary:not(.ant-btn-dangerous) {
  background-color: rgb(9, 88, 217) !important;
  border-color: rgb(9, 88, 217) !important;
}

.trackon-root .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: rgb(9, 88, 217) !important;
}

.trackon-root .ant-tabs-ink-bar {
  background: rgb(9, 88, 217) !important;
}

.trackon-root .ant-menu-dark .ant-menu-item-selected {
  background: rgb(9, 88, 217) !important;
}

.trackon-root .ant-tabs-nav-list {
  width: auto !important;
}

.trackon-root .ant-tabs-tab {
  flex: 0 0 auto !important;
  width: auto !important;
}

.trackon-root .ant-tabs-tab-btn {
  width: auto !important;
}

.trackon-root .ant-tabs-nav-wrap {
  display: flex !important;
}

.trackon-root .ant-tabs-tab-btn {
  font-size: 14px !important;
}

/* Fix Select component affected by parent styles (filter section) */
.trackon-root .ant-select .ant-select-selector {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  height: 32px !important;
  min-height: 32px !important;
}

.trackon-root .ant-select-single .ant-select-selector .ant-select-selection-item,
.trackon-root .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 30px !important;
  color: rgba(0, 0, 0, 0.88) !important;
}

.trackon-root .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  color: rgba(0, 0, 0, 0.35) !important;
}

.trackon-root .ant-select-focused .ant-select-selector {
  border-color: rgb(9, 88, 217) !important;
  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;
}

/*
 * Disabled Select: the parent app applies the grey "disabled" background to the
 * inner <input> instead of the whole selector, leaving uneven gaps at the start
 * and end. Put the disabled background on the selector (full width) and reset
 * the inner input to transparent so it looks consistent.
 */
.trackon-root .ant-select-disabled .ant-select-selector {
  background-color: rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

.trackon-root .ant-select-disabled .ant-select-selector input,
.trackon-root .ant-select-disabled .ant-select-selection-search,
.trackon-root .ant-select-disabled .ant-select-selection-search-input {
  background-color: transparent !important;
  background: transparent !important;
}

.trackon-root .ant-select-disabled .ant-select-selection-item,
.trackon-root .ant-select-disabled .ant-select-selection-placeholder {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* Fix DatePicker component affected by parent styles (filter section) */
.trackon-root .ant-picker {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  padding: 4px 11px !important;
}

.trackon-root .ant-picker-focused {
  border-color: rgb(9, 88, 217) !important;
  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;
}

.trackon-root .ant-picker .ant-picker-input > input {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.88) !important;
}

.trackon-root .ant-picker .ant-picker-input > input::placeholder {
  color: rgba(0, 0, 0, 0.35) !important;
}

/*
 * Fix odd background band behind the card title (e.g. "Download Template").
 * The parent app injects a background on the card header; reset it.
 */
.trackon-root .ant-card-head {
  background-color: transparent !important;
}

/*
 * The Filter popover content and its Select/DatePicker dropdowns render in a
 * portal appended to <body>, OUTSIDE .trackon-root, so the scoped rules above
 * cannot reach them. These classes are unique to Track-On, so we target them
 * directly to undo the parent app's global antd overrides.
 */
.project-filter-popup .ant-select .ant-select-selector,
.project-filter-popup .ant-picker {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.project-filter-popup .ant-select-single .ant-select-selection-item,
.project-filter-popup .ant-picker .ant-picker-input > input {
  color: rgba(0, 0, 0, 0.88) !important;
}

.project-filter-popup .ant-select-selection-placeholder,
.project-filter-popup .ant-picker .ant-picker-input > input::placeholder {
  color: rgba(0, 0, 0, 0.35) !important;
}

.project-filter-popup .ant-select-focused .ant-select-selector,
.project-filter-popup .ant-picker-focused {
  border-color: rgb(9, 88, 217) !important;
  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;
}

/* Disabled Select inside the portaled filter popover (see note above). */
.project-filter-popup .ant-select-disabled .ant-select-selector {
  background-color: rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

.project-filter-popup .ant-select-disabled .ant-select-selector input,
.project-filter-popup .ant-select-disabled .ant-select-selection-search,
.project-filter-popup .ant-select-disabled .ant-select-selection-search-input {
  background-color: transparent !important;
  background: transparent !important;
}

.project-filter-popup .ant-select-disabled .ant-select-selection-item,
.project-filter-popup .ant-select-disabled .ant-select-selection-placeholder {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* Disabled DatePicker */
.trackon-root .ant-picker-disabled {
  background-color: rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #d9d9d9 !important;
  cursor: not-allowed !important;
}

.trackon-root .ant-picker-disabled .ant-picker-input > input {
  color: rgba(0, 0, 0, 0.25) !important;
  background: transparent !important;
  cursor: not-allowed !important;
}

.trackon-root .ant-picker-disabled .ant-picker-suffix {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* Select/DatePicker option dropdowns for the filter (also portaled to body) */
.project-filter-popup-dropdown {
  background-color: #ffffff !important;
}

/*
 * Milestone & Invoice filter popover. Its content uses a different class
 * (.sf-filter-popup-content) and its Select/DatePicker dropdowns use
 * .milestone-month-picker-popup. Both are portaled to <body>, so they need
 * their own rules to undo the parent app's global antd overrides.
 */
.sf-filter-popup-content .ant-select .ant-select-selector,
.sf-filter-popup-content .ant-picker {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.sf-filter-popup-content .ant-select-single .ant-select-selection-item,
.sf-filter-popup-content .ant-picker .ant-picker-input > input {
  color: rgba(0, 0, 0, 0.88) !important;
}

.sf-filter-popup-content .ant-select-selection-placeholder,
.sf-filter-popup-content .ant-picker .ant-picker-input > input::placeholder {
  color: rgba(0, 0, 0, 0.35) !important;
}

.sf-filter-popup-content .ant-select-focused .ant-select-selector,
.sf-filter-popup-content .ant-picker-focused {
  border-color: rgb(9, 88, 217) !important;
  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;
}

.milestone-month-picker-popup {
  background-color: #ffffff !important;
}

/*
 * Primary buttons inside the body-portaled filter popovers (e.g. "Apply
 * Filters") don't inherit the .trackon-root color, so set the Track-On blue
 * directly on those popover classes.
 */
.project-filter-popup .ant-btn-primary,
.sf-filter-popup-content .ant-btn-primary {
  background-color: rgb(9, 88, 217) !important;
  border-color: rgb(9, 88, 217) !important;
}

/*
 * Fix antd table cell text picking up a blueish color from the parent app.
 * Reset to antd's default text color.
 */
.trackon-root .ant-table {
  color: rgba(0, 0, 0, 0.88) !important;
}

.trackon-root .ant-table-tbody > tr > td {
  color: rgba(0, 0, 0, 0.88) !important;
}

/*
 * Danger buttons (e.g. the "Delete" confirm button inside portaled
 * Popconfirm/Popover overlays) must keep antd's red danger color. The parent
 * app's global .ant-btn-primary styles otherwise leak into the portaled
 * overlay and turn the button dark blue.
 */
.trackon-root .ant-btn-primary.ant-btn-dangerous,
.trackon-root.ant-popover .ant-btn-primary.ant-btn-dangerous {
  background-color: #ff0000 !important;
  border-color: #ff0000 !important;
  color: #ffffff !important;
}

.trackon-root .ant-btn-primary.ant-btn-dangerous:hover,
.trackon-root.ant-popover .ant-btn-primary.ant-btn-dangerous:hover {
  background-color: #ff0000 !important;
  border-color: #ff0000 !important;
  color: #ffffff !important;
}


/* Let the multi-select grow with its tags instead of staying at 40px */
.business-area-select.ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 40px;
  padding: 4px 36px 4px 8px;
  align-items: flex-start;
}

.business-area-select.ant-select-multiple .ant-select-selection-overflow {
  flex-wrap: wrap;
  row-gap: 4px;
  width: 100%;
}

.business-area-select.ant-select-multiple .ant-select-selection-overflow-item {
  max-width: 100%;
}

.business-area-select.ant-select-multiple .ant-select-selection-item {
  max-width: 100%;
  margin-block: 0;
}

/* Pin the arrow and clear icons to the first row, not the vertical center */
.business-area-select.ant-select-multiple .ant-select-arrow,
.business-area-select.ant-select-multiple .ant-select-clear {
  top: 20px;
}



/* =========================================================
   ADMIN USER MANAGEMENT - ANT DESIGN SELECT
   Scoped only to AdminUserManagement Select components.

   IMPORTANT:
   - .admin-user-management = table selects
   - .admin-user-management-dialog = Edit User dialog selects
   - Existing Track-On Select styles above are untouched.
   ========================================================= */


/* =========================================================
   MAIN SELECT
   ========================================================= */

.admin-user-management .admin-user-antd-select,
.admin-user-management-dialog .admin-user-antd-select {
  width: 100%;
  min-width: 220px;

  font-family:
    "Segoe UI Variable Text",
    "Segoe UI",
    "Helvetica Neue",
    Arial,
    sans-serif;

  font-size: 14px !important;
}


/* =========================================================
   SELECT BOX
   ========================================================= */

.admin-user-management
  .admin-user-antd-select
  .ant-select-selector,

.admin-user-management-dialog
  .admin-user-antd-select
  .ant-select-selector {
  min-height: 40px !important;
  height: auto !important;

  display: flex !important;
  align-items: center !important;

  padding: 0 14px !important;

  background: #ffffff !important;

  /*
   * Keep the visible border that existed before.
   */
  border: 1px solid #d9d9d9 !important;

  border-radius: 6px !important;

  box-shadow: none !important;

  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease !important;
}


/* =========================================================
   HOVER
   ========================================================= */

.admin-user-management
  .admin-user-antd-select:not(.ant-select-disabled):hover
  .ant-select-selector,

.admin-user-management-dialog
  .admin-user-antd-select:not(.ant-select-disabled):hover
  .ant-select-selector {
  border-color: #8c8c8c !important;
}


/* =========================================================
   FOCUS / OPEN
   ========================================================= */

.admin-user-management
  .admin-user-antd-select.ant-select-focused
  .ant-select-selector,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-focused
  .ant-select-selector {
  border-color: rgb(9, 88, 217) !important;

  box-shadow:
    0 0 0 2px rgba(9, 88, 217, 0.1) !important;
}


/* =========================================================
   SELECTED TEXT
   ========================================================= */

.admin-user-management
  .admin-user-antd-select:not(.ant-select-multiple)
  .ant-select-selection-item,

.admin-user-management-dialog
  .admin-user-antd-select:not(.ant-select-multiple)
  .ant-select-selection-item {
  color: rgba(0, 0, 0, 0.88) !important;

  font-size: 14px !important;
  line-height: 38px !important;

  font-weight: 400 !important;
}


/* =========================================================
   PLACEHOLDER
   ========================================================= */

.admin-user-management
  .admin-user-antd-select:not(.ant-select-multiple)
  .ant-select-selection-placeholder,

.admin-user-management-dialog
  .admin-user-antd-select:not(.ant-select-multiple)
  .ant-select-selection-placeholder {
  color: rgba(0, 0, 0, 0.45) !important;

  font-size: 14px !important;
  line-height: 38px !important;

  opacity: 1 !important;
}


/* =========================================================
   ARROW
   ========================================================= */

.admin-user-management
  .admin-user-antd-select
  .ant-select-arrow,

.admin-user-management-dialog
  .admin-user-antd-select
  .ant-select-arrow {
  color: rgba(0, 0, 0, 0.45) !important;

  font-size: 14px !important;

  right: 13px !important;
}


/* =========================================================
   DISABLED SELECT
   ========================================================= */

.admin-user-management
  .admin-user-antd-select.ant-select-disabled
  .ant-select-selector,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-disabled
  .ant-select-selector {
  background: rgba(0, 0, 0, 0.04) !important;

  border: 1px solid #d9d9d9 !important;

  color: rgba(0, 0, 0, 0.25) !important;
}


.admin-user-management
  .admin-user-antd-select.ant-select-disabled
  .ant-select-selection-placeholder,

.admin-user-management
  .admin-user-antd-select.ant-select-disabled
  .ant-select-selection-item,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-disabled
  .ant-select-selection-placeholder,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-disabled
  .ant-select-selection-item {
  color: rgba(0, 0, 0, 0.25) !important;
}


/* =========================================================
   MULTIPLE SELECT
   ========================================================= */

.admin-user-management
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selector,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selector {
  min-height: 40px !important;
  height: auto !important;

  padding: 4px 38px 4px 10px !important;

  align-items: center !important;
}


.admin-user-management
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selection-wrap,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selection-wrap {
  align-items: center !important;
}


.admin-user-management
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selection-overflow,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selection-overflow {
  gap: 3px !important;
}


.admin-user-management
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selection-search,

.admin-user-management-dialog
  .admin-user-antd-select.ant-select-multiple
  .ant-select-selection-search {
  margin-inline-start: 0 !important;
}


/* =========================================================
   GREEN ACCOUNT TAG
   ========================================================= */

.admin-user-management .admin-user-account-tag {
  display: inline-flex;
  align-items: center;

  height: 24px;

  margin: 1px 3px 1px 0;
  padding: 0 8px;

  border: 1px solid #86efac;
  border-radius: 13px;

  background: #ecfdf3;
  color: #027a48;

  font-size: 12px !important;
  font-weight: 600;

  line-height: 22px;

  white-space: nowrap;
}

/* Keep Edit User styling unchanged. */
.admin-user-management-dialog .admin-user-account-tag {
  display: inline-flex;
  align-items: center;

  height: 28px;

  margin: 1px 3px 1px 0;
  padding: 0 10px;

  border: 1px solid #86efac;
  border-radius: 15px;

  background: #ecfdf3;
  color: #027a48;

  font-size: 14px !important;
  font-weight: 600;

  line-height: 26px;

  white-space: nowrap;
}


/* =========================================================
   PURPLE PROJECT TAG
   ========================================================= */

.admin-user-management .admin-user-project-tag {
  display: inline-flex;
  align-items: center;

  height: 24px;

  margin: 1px 3px 1px 0;
  padding: 0 8px;

  border: 1px solid #c4b5fd;
  border-radius: 13px;

  background: #f5f3ff;
  color: #6d28d9;

  font-size: 12px !important;
  font-weight: 600;

  line-height: 22px;

  white-space: nowrap;
}

/* Keep Edit User styling unchanged. */
.admin-user-management-dialog .admin-user-project-tag {
  display: inline-flex;
  align-items: center;

  height: 28px;

  margin: 1px 3px 1px 0;
  padding: 0 10px;

  border: 1px solid #c4b5fd;
  border-radius: 15px;

  background: #f5f3ff;
  color: #6d28d9;

  font-size: 14px !important;
  font-weight: 600;

  line-height: 26px;

  white-space: nowrap;
}


/* =========================================================
   ADMIN USER SELECT DROPDOWN
   ========================================================= */

/*
 * AntD renders Select dropdowns into document.body.
 *
 * Therefore this cannot be scoped under
 * .admin-user-management or .admin-user-management-dialog.
 *
 * The unique popupClassName:
 *
 *   admin-user-antd-select-dropdown
 *
 * ensures these rules affect only our Admin User Selects.
 */

.admin-user-antd-select-dropdown {
  z-index: 1500 !important;

  padding: 4px 0 !important;

  border-radius: 6px !important;

  background: #ffffff !important;

  box-shadow:
    0 5px 18px rgba(0, 0, 0, 0.16) !important;
}


/* =========================================================
   DROPDOWN OPTIONS
   ========================================================= */

.admin-user-antd-select-dropdown
  .ant-select-item {
  min-height: 38px !important;

  display: flex !important;
  align-items: center !important;

  padding: 6px 14px !important;

  color: rgba(0, 0, 0, 0.88) !important;

  font-family:
    "Segoe UI Variable Text",
    "Segoe UI",
    "Helvetica Neue",
    Arial,
    sans-serif !important;

  font-size: 14px !important;

  font-weight: 400 !important;

  border-radius: 0 !important;
}


/* =========================================================
   OPTION HOVER
   ========================================================= */

.admin-user-antd-select-dropdown
  .ant-select-item-option-active {
  background: #eef4ff !important;
}


/* =========================================================
   SELECTED OPTION
   ========================================================= */

.admin-user-antd-select-dropdown
  .ant-select-item-option-selected {
  background: #eef4ff !important;

  color: rgba(0, 0, 0, 0.88) !important;

  font-weight: 400 !important;
}


/* =========================================================
   SELECTED CHECK ICON
   ========================================================= */

.admin-user-antd-select-dropdown
  .ant-select-item-option-selected
  .ant-select-item-option-state {
  color: #2563eb !important;
}


/* =========================================================
   ROLE SELECT
   ========================================================= */

.admin-user-management .admin-user-role-select {
  min-width: 170px;
}


/* =========================================================
   ACCOUNT / PROJECT SELECT
   ========================================================= */

.admin-user-management .admin-user-account-select {
  min-width: 220px;
}

.admin-user-management .admin-user-project-select {
  min-width: 220px;
}


/* =========================================================
   EDIT DIALOG SELECT
   ========================================================= */

.admin-user-management-dialog .admin-user-edit-select {
  width: 100%;
  min-width: 0;
}


/* =========================================================
   RESPONSIVE
   ========================================================= */

@media (max-width: 900px) {
  .admin-user-management .admin-user-antd-select,
  .admin-user-management-dialog .admin-user-antd-select {
    min-width: 180px;
  }

  .admin-user-management .admin-user-role-select {
    min-width: 170px;
  }
}

/* =========================================================
   ADMIN USER TABLE SELECT LAYOUT FIX
   Prevent Account + Project Selects from overlapping.
   Scoped only to Admin User Management.
   ========================================================= */

.admin-user-management
  .admin-user-account-select,
.admin-user-management
  .admin-user-role-select,
.admin-user-management
  .admin-user-project-select {
  display: block !important;
  min-height: 40px !important;
  height: auto !important;
  box-sizing: border-box !important;
}

/* Single-select inner selector */
.admin-user-management
  .admin-user-account-select:not(.ant-select-multiple)
  .ant-select-selector,
.admin-user-management
  .admin-user-role-select:not(.ant-select-multiple)
  .ant-select-selector {
  height: 40px !important;
  min-height: 40px !important;
  box-sizing: border-box !important;
}

/* Multi-select inner selector: allow tags to wrap and grow vertically. */
.admin-user-management
  .admin-user-account-select.ant-select-multiple
  .ant-select-selector,
.admin-user-management
  .admin-user-role-select.ant-select-multiple
  .ant-select-selector,
.admin-user-management
  .admin-user-project-select.ant-select-multiple
  .ant-select-selector {
  min-height: 40px !important;
  height: auto !important;
  box-sizing: border-box !important;
  align-items: flex-start !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

/* Give stacked Account/Project controls a real gap instead of relying on
   the select's internal height. */
.admin-user-management
  .admin-user-account-select + .admin-user-project-select {
  margin-top: 4px !important;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/styles/trackon.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;;;;;EAKE;AACF;EACE,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;;EAGE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,wEAAwE;AACxE;EACE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;EAGE;AACF;EACE,wCAAwC;AAC1C;;AAEA;;;;;EAKE;AACF;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA,yEAAyE;AACzE;EACE,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;;EAGE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,gDAAgD;EAChD,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8EAA8E;AAC9E;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE;AACF;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE;AACF;;EAEE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;;EAGE;AACF;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;;EAKE;AACF;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;;AAGA,uEAAuE;AACvE;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;;EAEE,SAAS;AACX;;;;AAIA;;;;;;;;8DAQ8D;;;AAG9D;;8DAE8D;;AAE9D;;EAEE,WAAW;EACX,gBAAgB;;EAEhB;;;;;cAKY;;EAEZ,0BAA0B;AAC5B;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,2BAA2B;EAC3B,uBAAuB;;EAEvB,wBAAwB;EACxB,8BAA8B;;EAE9B,0BAA0B;;EAE1B,8BAA8B;;EAE9B;;IAEE;EACF,oCAAoC;;EAEpC,6BAA6B;;EAE7B,2BAA2B;;EAE3B;;oCAEkC;AACpC;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,gCAAgC;AAClC;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,wCAAwC;;EAExC;8CAC4C;AAC9C;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,qCAAqC;;EAErC,0BAA0B;EAC1B,4BAA4B;;EAE5B,2BAA2B;AAC7B;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,qCAAqC;;EAErC,0BAA0B;EAC1B,4BAA4B;;EAE5B,qBAAqB;AACvB;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,qCAAqC;;EAErC,0BAA0B;;EAE1B,sBAAsB;AACxB;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,0CAA0C;;EAE1C,oCAAoC;;EAEpC,qCAAqC;AACvC;;;AAGA;;;;;;;;;;;;;;;EAeE,qCAAqC;AACvC;;;AAGA;;8DAE8D;;AAE9D;;;;;;;EAOE,2BAA2B;EAC3B,uBAAuB;;EAEvB,qCAAqC;;EAErC,8BAA8B;AAChC;;;AAGA;;;;;;;EAOE,8BAA8B;AAChC;;;AAGA;;;;;;;EAOE,mBAAmB;AACrB;;;AAGA;;;;;;;EAOE,iCAAiC;AACnC;;;AAGA;;8DAE8D;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,YAAY;;EAEZ,qBAAqB;EACrB,cAAc;;EAEd,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;EACnB,cAAc;;EAEd,0BAA0B;EAC1B,gBAAgB;;EAEhB,iBAAiB;;EAEjB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,YAAY;;EAEZ,qBAAqB;EACrB,eAAe;;EAEf,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;EACnB,cAAc;;EAEd,0BAA0B;EAC1B,gBAAgB;;EAEhB,iBAAiB;;EAEjB,mBAAmB;AACrB;;;AAGA;;8DAE8D;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,YAAY;;EAEZ,qBAAqB;EACrB,cAAc;;EAEd,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;EACnB,cAAc;;EAEd,0BAA0B;EAC1B,gBAAgB;;EAEhB,iBAAiB;;EAEjB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,YAAY;;EAEZ,qBAAqB;EACrB,eAAe;;EAEf,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;EACnB,cAAc;;EAEd,0BAA0B;EAC1B,gBAAgB;;EAEhB,iBAAiB;;EAEjB,mBAAmB;AACrB;;;AAGA;;8DAE8D;;AAE9D;;;;;;;;;;;EAWE;;AAEF;EACE,wBAAwB;;EAExB,yBAAyB;;EAEzB,6BAA6B;;EAE7B,8BAA8B;;EAE9B;6CAC2C;AAC7C;;;AAGA;;8DAE8D;;AAE9D;;EAEE,2BAA2B;;EAE3B,wBAAwB;EACxB,8BAA8B;;EAE9B,4BAA4B;;EAE5B,qCAAqC;;EAErC;;;;;yBAKuB;;EAEvB,0BAA0B;;EAE1B,2BAA2B;;EAE3B,2BAA2B;AAC7B;;;AAGA;;8DAE8D;;AAE9D;;EAEE,8BAA8B;AAChC;;;AAGA;;8DAE8D;;AAE9D;;EAEE,8BAA8B;;EAE9B,qCAAqC;;EAErC,2BAA2B;AAC7B;;;AAGA;;8DAE8D;;AAE9D;;;EAGE,yBAAyB;AAC3B;;;AAGA;;8DAE8D;;AAE9D;EACE,gBAAgB;AAClB;;;AAGA;;8DAE8D;;AAE9D;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;8DAE8D;;AAE9D;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;;8DAE8D;;AAE9D;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;8DAI8D;;AAE9D;;;;;;EAME,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;;;;;;EAME,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,yEAAyE;AACzE;;;;;;;;;EASE,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;kCACkC;AAClC;;EAEE,0BAA0B;AAC5B","sourcesContent":[".trackon-root .ant-btn-primary:not(.ant-btn-dangerous) {\n  background-color: rgb(9, 88, 217) !important;\n  border-color: rgb(9, 88, 217) !important;\n}\n\n.trackon-root .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: rgb(9, 88, 217) !important;\n}\n\n.trackon-root .ant-tabs-ink-bar {\n  background: rgb(9, 88, 217) !important;\n}\n\n.trackon-root .ant-menu-dark .ant-menu-item-selected {\n  background: rgb(9, 88, 217) !important;\n}\n\n.trackon-root .ant-tabs-nav-list {\n  width: auto !important;\n}\n\n.trackon-root .ant-tabs-tab {\n  flex: 0 0 auto !important;\n  width: auto !important;\n}\n\n.trackon-root .ant-tabs-tab-btn {\n  width: auto !important;\n}\n\n.trackon-root .ant-tabs-nav-wrap {\n  display: flex !important;\n}\n\n.trackon-root .ant-tabs-tab-btn {\n  font-size: 14px !important;\n}\n\n/* Fix Select component affected by parent styles (filter section) */\n.trackon-root .ant-select .ant-select-selector {\n  background-color: #ffffff !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n  height: 32px !important;\n  min-height: 32px !important;\n}\n\n.trackon-root .ant-select-single .ant-select-selector .ant-select-selection-item,\n.trackon-root .ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 30px !important;\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.trackon-root .ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  color: rgba(0, 0, 0, 0.35) !important;\n}\n\n.trackon-root .ant-select-focused .ant-select-selector {\n  border-color: rgb(9, 88, 217) !important;\n  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;\n}\n\n/*\n * Disabled Select: the parent app applies the grey \"disabled\" background to the\n * inner <input> instead of the whole selector, leaving uneven gaps at the start\n * and end. Put the disabled background on the selector (full width) and reset\n * the inner input to transparent so it looks consistent.\n */\n.trackon-root .ant-select-disabled .ant-select-selector {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid #d9d9d9 !important;\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n.trackon-root .ant-select-disabled .ant-select-selector input,\n.trackon-root .ant-select-disabled .ant-select-selection-search,\n.trackon-root .ant-select-disabled .ant-select-selection-search-input {\n  background-color: transparent !important;\n  background: transparent !important;\n}\n\n.trackon-root .ant-select-disabled .ant-select-selection-item,\n.trackon-root .ant-select-disabled .ant-select-selection-placeholder {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n/* Fix DatePicker component affected by parent styles (filter section) */\n.trackon-root .ant-picker {\n  background-color: #ffffff !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n  padding: 4px 11px !important;\n}\n\n.trackon-root .ant-picker-focused {\n  border-color: rgb(9, 88, 217) !important;\n  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;\n}\n\n.trackon-root .ant-picker .ant-picker-input > input {\n  background-color: transparent !important;\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.trackon-root .ant-picker .ant-picker-input > input::placeholder {\n  color: rgba(0, 0, 0, 0.35) !important;\n}\n\n/*\n * Fix odd background band behind the card title (e.g. \"Download Template\").\n * The parent app injects a background on the card header; reset it.\n */\n.trackon-root .ant-card-head {\n  background-color: transparent !important;\n}\n\n/*\n * The Filter popover content and its Select/DatePicker dropdowns render in a\n * portal appended to <body>, OUTSIDE .trackon-root, so the scoped rules above\n * cannot reach them. These classes are unique to Track-On, so we target them\n * directly to undo the parent app's global antd overrides.\n */\n.project-filter-popup .ant-select .ant-select-selector,\n.project-filter-popup .ant-picker {\n  background-color: #ffffff !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n}\n\n.project-filter-popup .ant-select-single .ant-select-selection-item,\n.project-filter-popup .ant-picker .ant-picker-input > input {\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.project-filter-popup .ant-select-selection-placeholder,\n.project-filter-popup .ant-picker .ant-picker-input > input::placeholder {\n  color: rgba(0, 0, 0, 0.35) !important;\n}\n\n.project-filter-popup .ant-select-focused .ant-select-selector,\n.project-filter-popup .ant-picker-focused {\n  border-color: rgb(9, 88, 217) !important;\n  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;\n}\n\n/* Disabled Select inside the portaled filter popover (see note above). */\n.project-filter-popup .ant-select-disabled .ant-select-selector {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid #d9d9d9 !important;\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n.project-filter-popup .ant-select-disabled .ant-select-selector input,\n.project-filter-popup .ant-select-disabled .ant-select-selection-search,\n.project-filter-popup .ant-select-disabled .ant-select-selection-search-input {\n  background-color: transparent !important;\n  background: transparent !important;\n}\n\n.project-filter-popup .ant-select-disabled .ant-select-selection-item,\n.project-filter-popup .ant-select-disabled .ant-select-selection-placeholder {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n/* Disabled DatePicker */\n.trackon-root .ant-picker-disabled {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid #d9d9d9 !important;\n  cursor: not-allowed !important;\n}\n\n.trackon-root .ant-picker-disabled .ant-picker-input > input {\n  color: rgba(0, 0, 0, 0.25) !important;\n  background: transparent !important;\n  cursor: not-allowed !important;\n}\n\n.trackon-root .ant-picker-disabled .ant-picker-suffix {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n/* Select/DatePicker option dropdowns for the filter (also portaled to body) */\n.project-filter-popup-dropdown {\n  background-color: #ffffff !important;\n}\n\n/*\n * Milestone & Invoice filter popover. Its content uses a different class\n * (.sf-filter-popup-content) and its Select/DatePicker dropdowns use\n * .milestone-month-picker-popup. Both are portaled to <body>, so they need\n * their own rules to undo the parent app's global antd overrides.\n */\n.sf-filter-popup-content .ant-select .ant-select-selector,\n.sf-filter-popup-content .ant-picker {\n  background-color: #ffffff !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n}\n\n.sf-filter-popup-content .ant-select-single .ant-select-selection-item,\n.sf-filter-popup-content .ant-picker .ant-picker-input > input {\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.sf-filter-popup-content .ant-select-selection-placeholder,\n.sf-filter-popup-content .ant-picker .ant-picker-input > input::placeholder {\n  color: rgba(0, 0, 0, 0.35) !important;\n}\n\n.sf-filter-popup-content .ant-select-focused .ant-select-selector,\n.sf-filter-popup-content .ant-picker-focused {\n  border-color: rgb(9, 88, 217) !important;\n  box-shadow: 0 0 0 2px rgba(9, 88, 217, 0.1) !important;\n}\n\n.milestone-month-picker-popup {\n  background-color: #ffffff !important;\n}\n\n/*\n * Primary buttons inside the body-portaled filter popovers (e.g. \"Apply\n * Filters\") don't inherit the .trackon-root color, so set the Track-On blue\n * directly on those popover classes.\n */\n.project-filter-popup .ant-btn-primary,\n.sf-filter-popup-content .ant-btn-primary {\n  background-color: rgb(9, 88, 217) !important;\n  border-color: rgb(9, 88, 217) !important;\n}\n\n/*\n * Fix antd table cell text picking up a blueish color from the parent app.\n * Reset to antd's default text color.\n */\n.trackon-root .ant-table {\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.trackon-root .ant-table-tbody > tr > td {\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n/*\n * Danger buttons (e.g. the \"Delete\" confirm button inside portaled\n * Popconfirm/Popover overlays) must keep antd's red danger color. The parent\n * app's global .ant-btn-primary styles otherwise leak into the portaled\n * overlay and turn the button dark blue.\n */\n.trackon-root .ant-btn-primary.ant-btn-dangerous,\n.trackon-root.ant-popover .ant-btn-primary.ant-btn-dangerous {\n  background-color: #ff0000 !important;\n  border-color: #ff0000 !important;\n  color: #ffffff !important;\n}\n\n.trackon-root .ant-btn-primary.ant-btn-dangerous:hover,\n.trackon-root.ant-popover .ant-btn-primary.ant-btn-dangerous:hover {\n  background-color: #ff0000 !important;\n  border-color: #ff0000 !important;\n  color: #ffffff !important;\n}\n\n\n/* Let the multi-select grow with its tags instead of staying at 40px */\n.business-area-select.ant-select-multiple .ant-select-selector {\n  height: auto !important;\n  min-height: 40px;\n  padding: 4px 36px 4px 8px;\n  align-items: flex-start;\n}\n\n.business-area-select.ant-select-multiple .ant-select-selection-overflow {\n  flex-wrap: wrap;\n  row-gap: 4px;\n  width: 100%;\n}\n\n.business-area-select.ant-select-multiple .ant-select-selection-overflow-item {\n  max-width: 100%;\n}\n\n.business-area-select.ant-select-multiple .ant-select-selection-item {\n  max-width: 100%;\n  margin-block: 0;\n}\n\n/* Pin the arrow and clear icons to the first row, not the vertical center */\n.business-area-select.ant-select-multiple .ant-select-arrow,\n.business-area-select.ant-select-multiple .ant-select-clear {\n  top: 20px;\n}\n\n\n\n/* =========================================================\n   ADMIN USER MANAGEMENT - ANT DESIGN SELECT\n   Scoped only to AdminUserManagement Select components.\n\n   IMPORTANT:\n   - .admin-user-management = table selects\n   - .admin-user-management-dialog = Edit User dialog selects\n   - Existing Track-On Select styles above are untouched.\n   ========================================================= */\n\n\n/* =========================================================\n   MAIN SELECT\n   ========================================================= */\n\n.admin-user-management .admin-user-antd-select,\n.admin-user-management-dialog .admin-user-antd-select {\n  width: 100%;\n  min-width: 220px;\n\n  font-family:\n    \"Segoe UI Variable Text\",\n    \"Segoe UI\",\n    \"Helvetica Neue\",\n    Arial,\n    sans-serif;\n\n  font-size: 14px !important;\n}\n\n\n/* =========================================================\n   SELECT BOX\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select\n  .ant-select-selector,\n\n.admin-user-management-dialog\n  .admin-user-antd-select\n  .ant-select-selector {\n  min-height: 40px !important;\n  height: auto !important;\n\n  display: flex !important;\n  align-items: center !important;\n\n  padding: 0 14px !important;\n\n  background: #ffffff !important;\n\n  /*\n   * Keep the visible border that existed before.\n   */\n  border: 1px solid #d9d9d9 !important;\n\n  border-radius: 6px !important;\n\n  box-shadow: none !important;\n\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease !important;\n}\n\n\n/* =========================================================\n   HOVER\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select:not(.ant-select-disabled):hover\n  .ant-select-selector,\n\n.admin-user-management-dialog\n  .admin-user-antd-select:not(.ant-select-disabled):hover\n  .ant-select-selector {\n  border-color: #8c8c8c !important;\n}\n\n\n/* =========================================================\n   FOCUS / OPEN\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-focused\n  .ant-select-selector,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-focused\n  .ant-select-selector {\n  border-color: rgb(9, 88, 217) !important;\n\n  box-shadow:\n    0 0 0 2px rgba(9, 88, 217, 0.1) !important;\n}\n\n\n/* =========================================================\n   SELECTED TEXT\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select:not(.ant-select-multiple)\n  .ant-select-selection-item,\n\n.admin-user-management-dialog\n  .admin-user-antd-select:not(.ant-select-multiple)\n  .ant-select-selection-item {\n  color: rgba(0, 0, 0, 0.88) !important;\n\n  font-size: 14px !important;\n  line-height: 38px !important;\n\n  font-weight: 400 !important;\n}\n\n\n/* =========================================================\n   PLACEHOLDER\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select:not(.ant-select-multiple)\n  .ant-select-selection-placeholder,\n\n.admin-user-management-dialog\n  .admin-user-antd-select:not(.ant-select-multiple)\n  .ant-select-selection-placeholder {\n  color: rgba(0, 0, 0, 0.45) !important;\n\n  font-size: 14px !important;\n  line-height: 38px !important;\n\n  opacity: 1 !important;\n}\n\n\n/* =========================================================\n   ARROW\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select\n  .ant-select-arrow,\n\n.admin-user-management-dialog\n  .admin-user-antd-select\n  .ant-select-arrow {\n  color: rgba(0, 0, 0, 0.45) !important;\n\n  font-size: 14px !important;\n\n  right: 13px !important;\n}\n\n\n/* =========================================================\n   DISABLED SELECT\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-disabled\n  .ant-select-selector,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-disabled\n  .ant-select-selector {\n  background: rgba(0, 0, 0, 0.04) !important;\n\n  border: 1px solid #d9d9d9 !important;\n\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-disabled\n  .ant-select-selection-placeholder,\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-disabled\n  .ant-select-selection-item,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-disabled\n  .ant-select-selection-placeholder,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-disabled\n  .ant-select-selection-item {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n\n/* =========================================================\n   MULTIPLE SELECT\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selector,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selector {\n  min-height: 40px !important;\n  height: auto !important;\n\n  padding: 4px 38px 4px 10px !important;\n\n  align-items: center !important;\n}\n\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selection-wrap,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selection-wrap {\n  align-items: center !important;\n}\n\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selection-overflow,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selection-overflow {\n  gap: 3px !important;\n}\n\n\n.admin-user-management\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selection-search,\n\n.admin-user-management-dialog\n  .admin-user-antd-select.ant-select-multiple\n  .ant-select-selection-search {\n  margin-inline-start: 0 !important;\n}\n\n\n/* =========================================================\n   GREEN ACCOUNT TAG\n   ========================================================= */\n\n.admin-user-management .admin-user-account-tag {\n  display: inline-flex;\n  align-items: center;\n\n  height: 24px;\n\n  margin: 1px 3px 1px 0;\n  padding: 0 8px;\n\n  border: 1px solid #86efac;\n  border-radius: 13px;\n\n  background: #ecfdf3;\n  color: #027a48;\n\n  font-size: 12px !important;\n  font-weight: 600;\n\n  line-height: 22px;\n\n  white-space: nowrap;\n}\n\n/* Keep Edit User styling unchanged. */\n.admin-user-management-dialog .admin-user-account-tag {\n  display: inline-flex;\n  align-items: center;\n\n  height: 28px;\n\n  margin: 1px 3px 1px 0;\n  padding: 0 10px;\n\n  border: 1px solid #86efac;\n  border-radius: 15px;\n\n  background: #ecfdf3;\n  color: #027a48;\n\n  font-size: 14px !important;\n  font-weight: 600;\n\n  line-height: 26px;\n\n  white-space: nowrap;\n}\n\n\n/* =========================================================\n   PURPLE PROJECT TAG\n   ========================================================= */\n\n.admin-user-management .admin-user-project-tag {\n  display: inline-flex;\n  align-items: center;\n\n  height: 24px;\n\n  margin: 1px 3px 1px 0;\n  padding: 0 8px;\n\n  border: 1px solid #c4b5fd;\n  border-radius: 13px;\n\n  background: #f5f3ff;\n  color: #6d28d9;\n\n  font-size: 12px !important;\n  font-weight: 600;\n\n  line-height: 22px;\n\n  white-space: nowrap;\n}\n\n/* Keep Edit User styling unchanged. */\n.admin-user-management-dialog .admin-user-project-tag {\n  display: inline-flex;\n  align-items: center;\n\n  height: 28px;\n\n  margin: 1px 3px 1px 0;\n  padding: 0 10px;\n\n  border: 1px solid #c4b5fd;\n  border-radius: 15px;\n\n  background: #f5f3ff;\n  color: #6d28d9;\n\n  font-size: 14px !important;\n  font-weight: 600;\n\n  line-height: 26px;\n\n  white-space: nowrap;\n}\n\n\n/* =========================================================\n   ADMIN USER SELECT DROPDOWN\n   ========================================================= */\n\n/*\n * AntD renders Select dropdowns into document.body.\n *\n * Therefore this cannot be scoped under\n * .admin-user-management or .admin-user-management-dialog.\n *\n * The unique popupClassName:\n *\n *   admin-user-antd-select-dropdown\n *\n * ensures these rules affect only our Admin User Selects.\n */\n\n.admin-user-antd-select-dropdown {\n  z-index: 1500 !important;\n\n  padding: 4px 0 !important;\n\n  border-radius: 6px !important;\n\n  background: #ffffff !important;\n\n  box-shadow:\n    0 5px 18px rgba(0, 0, 0, 0.16) !important;\n}\n\n\n/* =========================================================\n   DROPDOWN OPTIONS\n   ========================================================= */\n\n.admin-user-antd-select-dropdown\n  .ant-select-item {\n  min-height: 38px !important;\n\n  display: flex !important;\n  align-items: center !important;\n\n  padding: 6px 14px !important;\n\n  color: rgba(0, 0, 0, 0.88) !important;\n\n  font-family:\n    \"Segoe UI Variable Text\",\n    \"Segoe UI\",\n    \"Helvetica Neue\",\n    Arial,\n    sans-serif !important;\n\n  font-size: 14px !important;\n\n  font-weight: 400 !important;\n\n  border-radius: 0 !important;\n}\n\n\n/* =========================================================\n   OPTION HOVER\n   ========================================================= */\n\n.admin-user-antd-select-dropdown\n  .ant-select-item-option-active {\n  background: #eef4ff !important;\n}\n\n\n/* =========================================================\n   SELECTED OPTION\n   ========================================================= */\n\n.admin-user-antd-select-dropdown\n  .ant-select-item-option-selected {\n  background: #eef4ff !important;\n\n  color: rgba(0, 0, 0, 0.88) !important;\n\n  font-weight: 400 !important;\n}\n\n\n/* =========================================================\n   SELECTED CHECK ICON\n   ========================================================= */\n\n.admin-user-antd-select-dropdown\n  .ant-select-item-option-selected\n  .ant-select-item-option-state {\n  color: #2563eb !important;\n}\n\n\n/* =========================================================\n   ROLE SELECT\n   ========================================================= */\n\n.admin-user-management .admin-user-role-select {\n  min-width: 170px;\n}\n\n\n/* =========================================================\n   ACCOUNT / PROJECT SELECT\n   ========================================================= */\n\n.admin-user-management .admin-user-account-select {\n  min-width: 220px;\n}\n\n.admin-user-management .admin-user-project-select {\n  min-width: 220px;\n}\n\n\n/* =========================================================\n   EDIT DIALOG SELECT\n   ========================================================= */\n\n.admin-user-management-dialog .admin-user-edit-select {\n  width: 100%;\n  min-width: 0;\n}\n\n\n/* =========================================================\n   RESPONSIVE\n   ========================================================= */\n\n@media (max-width: 900px) {\n  .admin-user-management .admin-user-antd-select,\n  .admin-user-management-dialog .admin-user-antd-select {\n    min-width: 180px;\n  }\n\n  .admin-user-management .admin-user-role-select {\n    min-width: 170px;\n  }\n}\n\n/* =========================================================\n   ADMIN USER TABLE SELECT LAYOUT FIX\n   Prevent Account + Project Selects from overlapping.\n   Scoped only to Admin User Management.\n   ========================================================= */\n\n.admin-user-management\n  .admin-user-account-select,\n.admin-user-management\n  .admin-user-role-select,\n.admin-user-management\n  .admin-user-project-select {\n  display: block !important;\n  min-height: 40px !important;\n  height: auto !important;\n  box-sizing: border-box !important;\n}\n\n/* Single-select inner selector */\n.admin-user-management\n  .admin-user-account-select:not(.ant-select-multiple)\n  .ant-select-selector,\n.admin-user-management\n  .admin-user-role-select:not(.ant-select-multiple)\n  .ant-select-selector {\n  height: 40px !important;\n  min-height: 40px !important;\n  box-sizing: border-box !important;\n}\n\n/* Multi-select inner selector: allow tags to wrap and grow vertically. */\n.admin-user-management\n  .admin-user-account-select.ant-select-multiple\n  .ant-select-selector,\n.admin-user-management\n  .admin-user-role-select.ant-select-multiple\n  .ant-select-selector,\n.admin-user-management\n  .admin-user-project-select.ant-select-multiple\n  .ant-select-selector {\n  min-height: 40px !important;\n  height: auto !important;\n  box-sizing: border-box !important;\n  align-items: flex-start !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n/* Give stacked Account/Project controls a real gap instead of relying on\n   the select's internal height. */\n.admin-user-management\n  .admin-user-account-select + .admin-user-project-select {\n  margin-top: 4px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
